export const langs = [
  {
    id: 'en',
    name: 'English',
  },
  {
    id: 'de',
    name: 'Deutsch',
  },
]

export const staticData = {
  cookieUserName: 'anecdobio-user',
  lsAnswerTitle: 'anecdobio-answer',
  lsAnswerIdTitle: 'anecdobio-answer-id',
}
